import React from 'react';
import { CmsButton, CmsFeature } from '../../types/contentstack';

interface CmsPageHeaderData {
  name?: string | null;
  features: CmsFeature[];
  paragraph_text?: string | null;
  button?: { id: string; item: CmsButton; text?: string }[] | [];
}

interface CmsPageHeaderProps {
  data: CmsPageHeaderData;
  className?: string;
}

export const CmsIconsAndCaption: React.FC<CmsPageHeaderProps> = ({ data, className = '' }) => {
  return (
    <div
      className={`bg-[#00478B] pt-800 pb-800 px-500 flex flex-col items-center justify-center ${className}`}
    >
      <div className="w-full max-w-[1440px] mx-auto flex flex-col items-center">
        {data.name && (
          <h2 className="text-white text-center font-bold text-heading-200 leading-heading mb-16">
            {data.name}
          </h2>
        )}
        {data.features && data.features.length > 0 && (
          <div className="w-full">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6">
              {data.features.map((cta) =>
                cta?.buttons?.map((btn) => (
                  <a
                    key={btn.text}
                    href={btn?.url}
                    target={btn?.target ?? (btn?.external ? '_blank' : '_self')}
                    rel={btn?.external ? 'noopener noreferrer' : undefined}
                    className="bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-lg p-6 flex items-center justify-between transition-all group"
                  >
                    <div className="flex items-center gap-4">
                      {cta.image?.url && (
                        <div className="flex-shrink-0">
                          <img
                            src={cta.image.url}
                            alt={cta.image.description}
                            className="w-12 h-12 object-contain"
                          />
                        </div>
                      )}
                      <span className="text-white font-semibold text-base">{btn.text}</span>
                    </div>
                    <svg
                      className="w-6 h-6 text-white flex-shrink-0 group-hover:translate-x-1 transition-transform"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </a>
                ))
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CmsIconsAndCaption;
